import { countrycodes } from '@prisma/client';
import { FranchiseWithLang } from '../types/franchise';
import { POST } from '../utils/requestUtils';
import { RoutesType } from '../utils/routes';
import { ODD_FORMAT } from '../pages/managers/types/managerProfileTypes';

interface CheckTokenResponse {
  Success: boolean;
  Data: {
    Franchises: FranchiseWithLang[];
    CountryCodes?: countrycodes[];
    Functions?: string[];
    ManagerCurrencyCode: string;
    ManagerId: number;
    FirstName: string;
    LastName: string;
    ManagerCurrencyId: string;
    OddsFormat: ODD_FORMAT;
    AutoCalculateOdds: boolean;
    TokenExpirationTime: number;
    Configuration: string;
    ManagerUuid: string;
    IsGlobal?: boolean;
    Routes: RoutesType[];
  }
}

export const checkToken = (token: string, configuration?: string | null, franchise?: string | null): Promise<CheckTokenResponse> => {
  const body = {
    token,
    configuration: franchise ? null : configuration, // If franchise is provided, configuration should be null (WBF only, will be removed)
    franchise,
  };
  return POST('api/auth/checkToken', body, true);
};
